import { getCountdownFromTimestamp } from './timeAndDates';

import { CIRCLE_END_DATE } from 'Constants/index';

export const getCircleCountdown = () => {
  const endDate = new Date(CIRCLE_END_DATE).getTime();
  const countdown = getCountdownFromTimestamp(endDate);
  return countdown ? `${countdown.value} ${countdown.unit} left` : 'Ending soon';
};
